/** @jsx isolateComponent */
import { Colors } from '@zapier/design-system';
import { css } from '@emotion/core';
import { isolateComponent } from '@zapier/common-utils';

type Props = {
  children: React.ReactNode;
  trimChildren: boolean;
};

const rootStyle = css({
  background: `linear-gradient(194.19deg, ${Colors.pink200} 0%, ${Colors.purple600} 101.17%)`,
  borderTopLeftRadius: 5,
  borderTopRightRadius: 5,
  color: Colors.white,
  overflow: 'hidden',
  textAlign: 'center',
});

const trimChildrenStyle = css({
  '& > *': {
    marginBottom: -10,
  },
});

const TrialWelcomeModalHeader = (props: Props) => {
  return (
    <div css={[rootStyle, props.trimChildren && trimChildrenStyle]}>
      {props.children}
    </div>
  );
};

TrialWelcomeModalHeader.defaultProps = {
  trimChildren: false,
};

export default TrialWelcomeModalHeader;
